import {animate} from '../../common/animate';

export const initIndexPromo = () => {
	const handleWindowResize = () => {
		const vh = window.innerHeight * 0.01;

		document.documentElement.style.setProperty( '--vh', `${vh}px` );
	};
	
	const indexPromo = document.querySelector( 'section.promo-header-index' );
	
	if ( !indexPromo )
	{
		return;
	}
	
	const picture = indexPromo.querySelector( 'picture' );
	const image = picture?.querySelector( 'img' );
	
	if ( picture && image )
	{
		const pictureRect = picture.getBoundingClientRect();
		
		const scrollScreen = () => {
			if ( window.pageYOffset > indexPromo.offsetHeight )
			{
				return;
			}
			
			const requestedPosition = indexPromo.offsetTop + indexPromo.offsetHeight;
			const currentPosition = window.pageYOffset;
			const calculateOffset = requestedPosition - currentPosition;
			
			animate( {
				duration: 500,
				timing( timeFraction )
				{
					return timeFraction;
				},
				draw( progress )
				{
					scrollTo( 0, currentPosition + ( calculateOffset * progress ) );
				},
			} );
		};
		
		const handleLoadImage = () => {
			const handleResizeWindow = () => {
				imageHeight = image.offsetHeight;
				const header = document.querySelector( 'header' );
				
				if ( header && header.nextElementSibling === indexPromo && window.innerWidth < 1024 )
				{
					picture.style.setProperty( 'top', `${header.offsetHeight - indexPromo.offsetTop}px` );
				}
				else
				{
					picture.style.removeProperty( 'top' );
				}
			};
			
			indexPromo.classList.add( 'loaded' );
			
			let imageHeight = image.offsetHeight;
			
			window.addEventListener( 'scroll', () => {
				if ( pictureRect.y <= 0 && pictureRect.y >= pictureRect.height * -1 )
				{
					// const topShift = ( imageHeight - pictureRect.height ) / window.innerHeight * window.pageYOffset;
					const opacityShift = 1 - ( 1 / pictureRect.height * window.pageYOffset );
					
					// image.style.top = `${topShift * -1}px`;
					image.style.opacity = opacityShift;
					indexPromo.querySelector( 'p' ).style.opacity = opacityShift;
					indexPromo.querySelector( 'a' ).style.opacity = opacityShift;
					indexPromo.querySelector( 'div.container' ).style.opacity = opacityShift;
				}
			} );
			
			window.addEventListener( 'resize', handleResizeWindow );
			
			document.addEventListener( 'keyup', ( evt ) => {
				if ( evt.key === 'ArrowDown' )
				{
					scrollScreen();
				}
			} );
			
			indexPromo.querySelector( 'button' )?.addEventListener( 'click', scrollScreen );
			
			handleResizeWindow();
		};
		
		if ( image.complete )
		{
			handleLoadImage();
		}
		else
		{
			image.addEventListener( 'load', handleLoadImage );
		}
	}

	handleWindowResize();
	window.addEventListener( 'resize', handleWindowResize );
};
